import { en } from './en'
import { fr } from './fr'

export const auth = {
  en,
  fr
}